import Template from 'backbone/platform/templates/assets/requirement_assetting_form.js.hamlc'
import FormattedNumber from 'utils/platform/formatted_number.js'

export default class RequirementAssettingFormView extends Backbone.View
  className: "delete-confirmation-wrapper list-item-wrapper"

  events:
    "click .js-remove-asset" : "onDelete"

  initialize: (options) ->
    @asset = options.asset
    @assetable_type = options.assetable_type
    @publication = options.publication
    @supportedImageFileExtensions = options.supportedImageFileExtensions || []

  render: ->
    @$el.html Template
      asset: @asset,
      assetable_type: @assetable_type,
      attachedFileIsImage: @_attachedFileIsImage()
      FormattedNumber: FormattedNumber

    if @_publicationRequiresImage() && @_attachedFileIsImage()
      # resets the ui validation to require image
      $("article form:visible").parsley().reset()

    this

  onDelete: ->
    if @asset.get("persisted")
      $.ajax("/stories/#{@asset.get("assetable_id")}/assets/#{@asset.get("asset_id")}",
        method: "delete")

    @remove()

  _publicationRequiresImage: ->
    @publication && @publication.get('requireImage')

  _attachedFileIsImage: ->
    @_identifyImageByFileType() || @_identifyImageByTitle() || false

  _identifyImageByFileType: ->
    @asset.get("fileType") && @asset.get("fileType").match(@_imgExtMatcher())

  _identifyImageByTitle: ->
    @asset.get('title').split('/').slice(-1).pop().split('?')[0].match(@_imgExtMatcher())

  _imgExtMatcher: ->
    new RegExp(".(" + @supportedImageFileExtensions.join("|") + ")$", 'i')



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/views/assets/requirement_assetting_form_view.js.coffee